import AddEquipment from "./AddEquipment";
import DeleteConfirmation from "./DeleteConfirmation";
import EquipmentKitDialog from "./EquipmentKitDialog";

const Dialogs = {
  AddEquipment,
  DeleteConfirmation,
  EquipmentKitDialog,
}

export default Dialogs;